export const canonicalArc = "Ma'at -> Wêb -> Sia -> Ren -> Ib -> Hu -> Heka -> Ma'at-Kheru";

export const sevenStageJourney = [
  {
    "id": "ignorance",
    "title": {
      "en": "Ignorance",
      "es": "Ignorancia",
      "nl": "Onwetendheid",
      "pap": "Inyoransia"
    },
    "image": "/assets/images/stage-ignorance-realistic.png",
    "imageAlt": {
      "en": "Realistic threshold image for the Ignorance stage",
      "es": "Imagen realista del umbral para la etapa de la Ignorancia",
      "nl": "Realistische drempelafbeelding voor de fase Onwetendheid",
      "pap": "Imagen realístiko di umbral pa e fase di Inyoransia"
    },
    "description": {
      "en": "The starting condition: confusion, inherited scripts, and unconscious participation in disorder.",
      "es": "La condición inicial: confusión, guiones heredados y participación inconsciente en el desorden.",
      "nl": "De begintoestand: verwarring, overgeërfde scripts en onbewuste deelname aan wanorde.",
      "pap": "E kondishon inisial: konfushon, skèdènan eredá i partisipashon inkonsiente den desòrden."
    }
  },
  {
    "id": "awareness",
    "title": {
      "en": "Awareness",
      "es": "Conciencia",
      "nl": "Bewustzijn",
      "pap": "Konsenshi"
    },
    "image": "/assets/images/stage-awareness-realistic.png",
    "imageAlt": {
      "en": "Realistic threshold image for the Awareness stage",
      "es": "Imagen realista del umbral para la etapa de la Conciencia",
      "nl": "Realistische drempelafbeelding voor de fase Bewustzijn",
      "pap": "Imagen realístiko di umbral pa e fase di Konsenshi"
    },
    "description": {
      "en": "The first seeing: recognizing that perception, behavior, and consequence are connected.",
      "es": "La primera visión: reconocer que la percepción, la conducta y la consecuencia están conectadas.",
      "nl": "Het eerste zien: erkennen dat waarneming, gedrag en gevolg met elkaar verbonden zijn.",
      "pap": "E promé mirada: rekonosé ku persepshon, komportashon i konsekuensia ta konektá."
    }
  },
  {
    "id": "understanding",
    "title": {
      "en": "Understanding",
      "es": "Comprensión",
      "nl": "Begrip",
      "pap": "Komprondementu"
    },
    "image": "/assets/images/stage-understanding-realistic.png",
    "imageAlt": {
      "en": "Realistic study image for the Understanding stage",
      "es": "Imagen realista de estudio para la etapa de la Comprensión",
      "nl": "Realistische studieafbeelding voor de fase Begrip",
      "pap": "Imagen realístiko di estudio pa e fase di Komprondementu"
    },
    "description": {
      "en": "The ordering phase: studying principles until the Work has structure, language, and moral direction.",
      "es": "La fase de ordenamiento: estudiar los principios hasta que la Obra tenga estructura, lenguaje y dirección moral.",
      "nl": "De ordenende fase: principes bestuderen tot het Werk structuur, taal en morele richting heeft.",
      "pap": "E fase di òrden: studia prinsipionan te ora e Obra tin struktura, idioma i direkshon moral."
    }
  },
  {
    "id": "integration",
    "title": {
      "en": "Integration",
      "es": "Integración",
      "nl": "Integratie",
      "pap": "Integrashon"
    },
    "image": "/assets/images/stage-integration-realistic.png",
    "imageAlt": {
      "en": "Realistic harmonization image for the Integration stage",
      "es": "Imagen realista de armonización para la etapa de la Integración",
      "nl": "Realistische harmonisatieafbeelding voor de fase Integratie",
      "pap": "Imagen realístiko di armonisashon pa e fase di Integrashon"
    },
    "description": {
      "en": "The bridge: bringing principle into thought, speech, body, relationships, and daily choice.",
      "es": "El puente: llevar el principio al pensamiento, el habla, el cuerpo, las relaciones y la elección diaria.",
      "nl": "De brug: het principe brengen in denken, spreken, lichaam, relaties en dagelijkse keuzes.",
      "pap": "E pont: trese e prinsipio den pensamentu, den loke bo ta papia, den kurpa, relashonnan i eskoho diario."
    }
  },
  {
    "id": "embodiment",
    "title": {
      "en": "Embodiment",
      "es": "Encarnación",
      "nl": "Belichaming",
      "pap": "Enkarnashon"
    },
    "image": "/assets/images/stage-embodiment-realistic.png",
    "imageAlt": {
      "en": "Realistic discipline image for the Embodiment stage",
      "es": "Imagen realista de disciplina para la etapa de la Encarnación",
      "nl": "Realistische discipline-afbeelding voor de fase Belichaming",
      "pap": "Imagen realístiko di disiplina pa e fase di Enkarnashon"
    },
    "description": {
      "en": "The test: truth becomes observable conduct rather than stored information.",
      "es": "La prueba: la verdad se vuelve conducta observable en lugar de información almacenada.",
      "nl": "De test: waarheid wordt waarneembaar gedrag in plaats van opgeslagen informatie.",
      "pap": "E prueba: bèrdat ta bira komportashon observabel en bes di informashon almasená."
    }
  },
  {
    "id": "mastery",
    "title": {
      "en": "Mastery",
      "es": "Maestría",
      "nl": "Meesterschap",
      "pap": "Maestria"
    },
    "image": "/assets/images/stage-mastery-realistic.png",
    "imageAlt": {
      "en": "Realistic mastery image for the Mastery stage",
      "es": "Imagen realista de maestría para la etapa de la Maestría",
      "nl": "Realistische meesterschapsafbeelding voor de fase Meesterschap",
      "pap": "Imagen realístiko di maestria pa e fase di Maestria"
    },
    "description": {
      "en": "The disciplined state: freedom, responsibility, and skill are held without dependency on the teacher.",
      "es": "El estado disciplinado: la libertad, la responsabilidad y la habilidad se sostienen sin depender del maestro.",
      "nl": "De gedisciplineerde staat: vrijheid, verantwoordelijkheid en vaardigheid worden vastgehouden zonder afhankelijkheid van de leraar.",
      "pap": "E estado disipliná: libertat, responsabilidat i abilidat ta wòrdu teni sin dependé di e maestro."
    }
  },
  {
    "id": "service",
    "title": {
      "en": "Service",
      "es": "Servicio",
      "nl": "Dienstbaarheid",
      "pap": "Servisio"
    },
    "image": "/assets/images/stage-service-realistic.png",
    "imageAlt": {
      "en": "Realistic service image for the Service stage",
      "es": "Imagen realista de servicio para la etapa del Servicio",
      "nl": "Realistische dienstbaarheidsafbeelding voor de fase Dienstbaarheid",
      "pap": "Imagen realístiko di servisio pa e fase di Servisio"
    },
    "description": {
      "en": "The return: what was clarified is offered back without ownership, coercion, or exploitation.",
      "es": "El retorno: lo que fue clarificado se ofrece de vuelta sin posesión, coerción ni explotación.",
      "nl": "De terugkeer: wat verhelderd is, wordt teruggegeven zonder eigendom, dwang of uitbuiting.",
      "pap": "E bòlbementu: loke a wòrdu klariá ta wòrdu ofresí bèk sin propiedat, koakshon ni eksplotashon."
    }
  }
];

export const pageContent = {
  "home": {
    "heroText": {
      "en": "A public threshold into initiatic education: purification before explanation, coherence before consumption, and service after mastery.",
      "es": "Un umbral público hacia la educación iniciática: purificación antes de la explicación, coherencia antes del consumo y servicio después de la maestría.",
      "nl": "Een publieke drempel naar initiatisch onderwijs: zuivering vóór uitleg, coherentie vóór consumptie en dienstbaarheid na meesterschap.",
      "pap": "Un umbral públiko pa edukashon inisiátiko: purifikashon promé ku splikashon, koherensia promé ku konsumashon, i servisio despues di maestria."
    },
    "announcementTitle": {
      "en": "Begin your path",
      "es": "Comienza tu camino",
      "nl": "Begin je pad",
      "pap": "Kuminsá bo kaminda"
    },
    "announcementText": {
      "en": "Begin with the curated path, then continue into the deeper media, programs, and study materials.",
      "es": "Comienza con el camino curado y continúa después hacia los medios, programas y materiales de estudio más profundos.",
      "nl": "Begin met het zorgvuldig opgebouwde pad en ga daarna verder naar diepere media, programma's en studiematerialen.",
      "pap": "Kuminsá ku e kaminda kurá, despues sigui den media, programanan i materialnan di estudio mas profundo."
    },
    "programsTitle": {
      "en": "Podcasts to Re-Member",
      "es": "Podcasts para Re-Cordar",
      "nl": "Podcasts om te Her-Inneren",
      "pap": "Podcasts pa Kòrda atrobe"
    },
    "programsText": {
      "en": "The MP3 podcast archive follows the verified RSS order and embeds the audio player directly in each horizontal card.",
      "es": "El archivo MP3 de podcasts sigue el orden del RSS y muestra el reproductor de audio directamente en cada tarjeta horizontal.",
      "nl": "Het MP3-podcastarchief volgt de RSS-volgorde en toont de audiospeler direct in elke horizontale kaart.",
      "pap": "E archivo MP3 di podcast ta sigui orden di RSS i ta mustra e player di audio direktamente den kada karta horizontal."
    },
    "coursesTitle": {
      "en": "Prepare for deeper study",
      "es": "Prepárate para un estudio más profundo",
      "nl": "Bereid je voor op diepere studie",
      "pap": "Prepará pa estudio mas profundo"
    },
    "coursesText": {
      "en": "Courses point toward practice and the protected University boundary without bypassing the public threshold.",
      "es": "Los cursos orientan hacia la práctica y hacia el límite protegido de la Universidad sin saltar el umbral público.",
      "nl": "Cursussen wijzen naar oefening en naar de beschermde grens van de Universiteit zonder de publieke drempel over te slaan.",
      "pap": "Kursonan ta guia bo pa práktika i pa e frontera protegí di Universidat sin pasa banda di e umbral públiko."
    },
    "eventsTitle": {
      "en": "Events",
      "es": "Eventos",
      "nl": "Evenementen",
      "pap": "Eventonan"
    },
    "eventsText": {
      "en": "Events are the live public threshold: sessions, announcements, and replays are published here when they are ready for public study.",
      "es": "Los eventos son el umbral público en vivo: sesiones, anuncios y repeticiones se publican aquí cuando están listos para el estudio público.",
      "nl": "Evenementen vormen de levende publieke drempel: sessies, aankondigingen en herhalingen verschijnen hier wanneer ze klaar zijn voor publieke studie.",
      "pap": "Eventonan ta e umbral públiko na bibo: seshonnan, anunsionan i replaynan ta sali aki ora nan ta kla pa estudio públiko."
    },
    "articlesTitle": {
      "en": "Read articles",
      "es": "Lee artículos",
      "nl": "Lees artikelen",
      "pap": "Lesa artikulonan"
    },
    "articlesText": {
      "en": "Article PDFs and summaries remain traceable to the TGWE archive.",
      "es": "Los PDF y resumenes de articulos permanecen conectados al archivo de TGWE.",
      "nl": "Artikel-PDF's en samenvattingen blijven verbonden met het TGWE-archief.",
      "pap": "PDFnan i resumennan di artikulo ta keda konekta na e archivo di TGWE."
    },
    "episodesTitle": {
      "en": "Latest preserved transmissions",
      "es": "Transmisiones recientes",
      "nl": "Recente uitzendingen",
      "pap": "Transmishonnan resien"
    },
    "episodesText": {
      "en": "Selected media cards are shown as preserved transmissions while later phases curate canonical sequencing.",
      "es": "Tarjetas de medios seleccionadas se muestran como transmisiones de estudio mientras continua la organizacion canonica.",
      "nl": "Geselecteerde mediakaarten worden getoond als studie-uitzendingen terwijl de canonieke ordening doorgaat.",
      "pap": "Kartanan di media selekta ta wordu mustra komo transmishonnan di estudio mientras ordenashon kanoniko ta sigui."
    },
    "supportTitle": {
      "en": "Support the Work without dependency",
      "es": "Apoya la Obra sin dependencia",
      "nl": "Steun het Werk zonder afhankelijkheid",
      "pap": "Sostené e Obra sin dependensia"
    },
    "supportText": {
      "en": "Support keeps the public threshold available. It does not purchase authority, spiritual access, or private dependency.",
      "es": "El apoyo mantiene disponible el umbral público. No compra autoridad, acceso espiritual ni dependencia privada.",
      "nl": "Steun houdt de publieke drempel beschikbaar. Het koopt geen gezag, spirituele toegang of persoonlijke afhankelijkheid.",
      "pap": "Sosten ta tene e umbral públiko disponibel. E no ta kumpra outoridat, akseso spiritual òf dependensia privá."
    }
  },
  "startHere": {
    "intro": {
      "en": "The path begins by correcting orientation. TGWE is not a content dump; it is a public threshold into disciplined self-education.",
      "es": "El camino comienza corrigiendo la orientación. TGWE no es un depósito de contenido; es un umbral público hacia la autoeducación disciplinada.",
      "nl": "Het pad begint met het corrigeren van oriëntatie. TGWE is geen contentdump; het is een publieke drempel naar gedisciplineerde zelfeducatie.",
      "pap": "E kaminda ta kuminsá ku korekshon di orientashon. TGWE no ta un depósitu di kontenido; e ta un umbral públiko pa auto-edukashon disipliná."
    },
    "stageTitle": {
      "en": "The seven-stage arc",
      "es": "El arco de siete etapas",
      "nl": "De zevenfasige boog",
      "pap": "E arko di shete etapa"
    },
    "teacherCompanion": {
      "en": "The teacher functions as a companion and witness, not as an owner of the student's perception. The aim is independence through right relationship with truth.",
      "es": "El maestro funciona como acompañante y testigo, no como dueño de la percepción del estudiante. El objetivo es independencia mediante una relación correcta con la verdad.",
      "nl": "De leraar functioneert als metgezel en getuige, niet als eigenaar van de waarneming van de student. Het doel is onafhankelijkheid door een juiste verhouding tot waarheid.",
      "pap": "E maestro ta funshoná komo kompanero i testigu, no komo dueño di persepshon di e studiante. E meta ta independensia pa medio di relashon korekto ku bèrdat."
    },
    "firstMaterialsTitle": {
      "en": "First materials",
      "es": "Primeros materiales",
      "nl": "Eerste materialen",
      "pap": "Promé materialnan"
    },
    "firstMaterialsText": {
      "en": "Begin with the foundations program, the threshold course, the article library, and the University boundary when you are ready for protected deeper work.",
      "es": "Comienza con el programa de fundamentos, el curso de umbral, la biblioteca de artículos y el límite de la Universidad cuando estés listo para un trabajo profundo protegido.",
      "nl": "Begin met het fundamentenprogramma, de drempelcursus, de artikelbibliotheek en de grens van de Universiteit wanneer je klaar bent voor beschermd dieper werk.",
      "pap": "Kuminsá ku e programa di fundamentonan, e kurso di umbral, e biblioteka di artíkulonan i e frontera di Universidat ora bo ta kla pa trabou profundo protegí."
    },
    "reversibilityTitle": {
      "en": "Reversible entry",
      "es": "Entrada reversible",
      "nl": "Omkeerbare toegang",
      "pap": "Entrada reversibel"
    },
    "reversibilityText": {
      "en": "You can return to the public selection state at any point: Podcasts for audio transmissions, Videos for media cycles, Courses for practice, Articles for study texts, Library for materials, and University for the separate protected application.",
      "es": "Puedes volver al estado público de selección en cualquier momento: Podcasts para transmisiones de audio, Videos para ciclos multimedia, Cursos para práctica, Artículos para textos de estudio, Biblioteca para materiales y Universidad para la aplicación protegida separada.",
      "nl": "Je kunt op elk moment terugkeren naar de publieke selectiestaat: Podcasts voor audiotransmissies, Video's voor mediacycli, Cursussen voor oefening, Artikelen voor studieteksten, Bibliotheek voor materialen en Universiteit voor de afzonderlijke beschermde toepassing.",
      "pap": "Bo por bolbe na e estado públiko di selekshon na kualke momento: Podcasts pa transmishonnan di audio, Videos pa siklonan di media, Kursonan pa práktika, Artikulonan pa tekstonan di estudio, Biblioteka pa materialnan, i Universidat pa e aplikashon protegí separá."
    }
  },
  "indexes": {
    "programs": {
      "intro": {
        "en": "Podcasts presents the TGWE MP3 archive in chronological order with direct audio players and linked study materials.",
        "es": "Podcasts presenta el archivo MP3 de TGWE en orden cronologico con reproductores de audio directos y materiales de estudio vinculados.",
        "nl": "Podcasts toont het TGWE MP3-archief in chronologische volgorde met directe audiospelers en gekoppelde studiematerialen.",
        "pap": "Podcasts ta presenta e archivo MP3 di TGWE den orden kronologiko ku playernan di audio direktamente i materialnan di estudio konekta."
      },
      "canonicalTitle": {
        "en": "Canonical programs",
        "es": "Programas canonicos",
        "nl": "Canonieke programma's",
        "pap": "Programanan kanoniko"
      },
      "archiveTitle": {
        "en": "Archive programs",
        "es": "Programas de archivo",
        "nl": "Archiefprogramma's",
        "pap": "Programanan di archivo"
      }
    },
    "media": {
      "intro": {
        "en": "Videos presents the seven-cycle structure cleanly: Cycle 1 opens into one horizontal row per Eigen Pad season, with embedded video where available.",
        "es": "Videos presenta claramente la estructura de siete ciclos: el Ciclo 1 abre una fila horizontal por temporada de Eigen Pad, con video integrado cuando esta disponible.",
        "nl": "Video's toont de structuur van zeven cycli helder: Cyclus 1 opent een horizontale rij per Eigen Pad-seizoen, met ingesloten video waar beschikbaar.",
        "pap": "Videos ta presenta e struktura di shete siklo kla: Siklo 1 ta habri un rei horizontal pa kada temporada di Eigen Pad, ku video integra ora e ta disponibel."
      }
    },
    "courses": {
      "intro": {
        "en": "Courses are practice containers. Public courses prepare entry; protected study remains inside /university/.",
        "es": "Los cursos son contenedores de práctica. Los cursos públicos preparan la entrada; el estudio protegido permanece dentro de /university/.",
        "nl": "Cursussen zijn oefencontainers. Publieke cursussen bereiden de toegang voor; beschermde studie blijft binnen /university/.",
        "pap": "Kursonan ta kontenedó di práktika. Kursonan públiko ta prepará entrada; estudio protegí ta keda den /university/."
      },
      "boundaryTitle": {
        "en": "University boundary",
        "es": "Límite de la Universidad",
        "nl": "Grens van de Universiteit",
        "pap": "Frontera di Universidat"
      },
      "boundaryText": {
        "en": "/university/ remains a separate, protected study space, reached on its own rather than through the main public pages.",
        "es": "/university/ sigue siendo un espacio de estudio protegido e independiente, al que se accede por separado y no a través de las páginas públicas principales.",
        "nl": "/university/ blijft een afzonderlijke, beschermde studieruimte die je apart bereikt en niet via de algemene publieke pagina's.",
        "pap": "/university/ ta keda un espasio di estudio protegí i separá, ku bo ta yega na dje aparte i no via e páginanan públiko prinsipal."
      }
    },
    "events": {
      "intro": {
        "en": "Events are grouped by lifecycle state so upcoming, live, replay, and past material remain distinct.",
        "es": "Los eventos se agrupan por estado para mantener separados los próximos, en vivo, repeticiones y pasados.",
        "nl": "Evenementen worden gegroepeerd per status zodat aankomend, live, herhaling en verleden duidelijk gescheiden blijven.",
        "pap": "Eventonan ta agrupá segun estado pa tene futuro, na bibo, replay i pasado separá."
      }
    },
    "articles": {
      "intro": {
        "en": "Articles are sorted by date with readable summaries and direct PDF downloads where available.",
        "es": "Los articulos se ordenan por fecha con resumenes legibles y descargas PDF directas cuando estan disponibles.",
        "nl": "Artikelen staan op datum met leesbare samenvattingen en directe PDF-downloads waar beschikbaar.",
        "pap": "Artikulonan ta ordena segun fecha ku resumennan lesabel i downloadnan PDF direktamente ora nan ta disponibel."
      }
    },
    "library": {
      "intro": {
        "en": "The Library exposes material links by category. It is a catalog, not an initiatic sequence.",
        "es": "La Biblioteca muestra enlaces de materiales por categoria. Es un catalogo, no una secuencia iniciatica.",
        "nl": "De Bibliotheek toont materiaallinks per categorie. Het is een catalogus, geen initiatische reeks.",
        "pap": "Biblioteka ta mustra linknan di material segun kategoria. E ta un katalogo, no un sekuensia inisiatiko."
      }
    },
    "downloads": {
      "intro": {
        "en": "Downloads are grouped by category and status. A release link appears only when it is ready for public use.",
        "es": "Las descargas se agrupan por categoria y estado. Un enlace de lanzamiento aparece solo cuando esta listo para uso publico.",
        "nl": "Downloads zijn gegroepeerd op categorie en status. Een releaselink verschijnt pas wanneer die klaar is voor publiek gebruik.",
        "pap": "Downloadnan ta agrupa segun kategoria i estado. Un link di lansamentu ta aparece solamente ora e ta kla pa uso publiko."
      }
    }
  },
  "about": {
    "intro": {
      "en": "The Great Work Experience exists to support truth, freedom, natural law, and self-sovereign education without dependency creation.",
      "es": "The Great Work Experience existe para apoyar la verdad, la libertad, la ley natural y la educación soberana sin crear dependencia.",
      "nl": "The Great Work Experience bestaat om waarheid, vrijheid, natuurwet en zelf-soeverein onderwijs te ondersteunen zonder afhankelijkheid te creëren.",
      "pap": "The Great Work Experience ta eksistí pa sostené bèrdat, libertat, lei natural i edukashon soberano sin krea dependensia."
    },
    "missionTitle": {
      "en": "Mission",
      "es": "Misión",
      "nl": "Missie",
      "pap": "Mishon"
    },
    "missionText": {
      "en": "TGWE preserves and presents material for those who choose to study principles, morality, consciousness, and right action. The work is offered as a threshold, not as a closed authority structure.",
      "es": "TGWE preserva y presenta material para quienes eligen estudiar principios, moralidad, consciencia y acción correcta. La Obra se ofrece como umbral, no como una estructura cerrada de autoridad.",
      "nl": "TGWE bewaart en presenteert materiaal voor wie principes, moraliteit, bewustzijn en juist handelen wil bestuderen. Het Werk wordt aangeboden als drempel, niet als gesloten gezagsstructuur.",
      "pap": "TGWE ta preservá i presentá material pa esnan ku ta skohe studia prinsipionan, moralidat, konsenshi i akshon korekto. E Obra ta wordu ofresé komo umbral, no komo struktura será di outoridat."
    },
    "covenantTitle": {
      "en": "Ethical covenant",
      "es": "Pacto ético",
      "nl": "Ethisch verbond",
      "pap": "Paktu étiko"
    },
    "founderTitle": {
      "en": "Founder",
      "es": "Fundador",
      "nl": "Oprichter",
      "pap": "Fundadó"
    },
    "socialTitle": {
      "en": "Public channels",
      "es": "Canales publicos",
      "nl": "Publieke kanalen",
      "pap": "Kanalnan publiko"
    },
    "contactTitle": {
      "en": "Contact",
      "es": "Contacto",
      "nl": "Contact",
      "pap": "Kontakto"
    },
    "contactText": {
      "en": "The legacy contact page contains contact data. Until a verified contact address is supplied, contact is represented through the public channels listed here.",
      "es": "El contacto publico se representa por medio de los canales listados aqui hasta que se publique una direccion de contacto directa.",
      "nl": "Publiek contact loopt via de kanalen die hier staan totdat een direct contactadres wordt gepubliceerd.",
      "pap": "Kontakto publiko ta pasa via e kanalnan lista aki te ora un adres di kontakto direktamente wordu publika."
    },
    "sourceNote": {
      "en": "Biography, books, networks, and covenant principles are presented for orientation and public accountability.",
      "es": "La biografía, los libros, las redes y los principios del pacto se presentan para orientación y responsabilidad pública.",
      "nl": "Biografie, boeken, netwerken en verbondsprincipes worden gepresenteerd voor oriëntatie en publieke verantwoording.",
      "pap": "Biografia, bukinan, retnan i prinsipionan di paktu ta presentá pa orientashon i responsabilidat públiko."
    }
  },
  "donate": {
    "intro": {
      "en": "Support is accepted only as support. It does not create rank, dependency, spiritual privilege, or control over the Work. If you find the information on the website valuable, please consider making a donation to support the good work and bring this information to thousands of children and adults.",
      "es": "El apoyo se acepta solo como apoyo. No crea rango, dependencia, privilegio espiritual ni control sobre la Obra. Si encuentras valiosa la información del sitio web, considera hacer una donación para apoyar el buen trabajo y llevar esta información a miles de niños y adultos.",
      "nl": "Steun wordt alleen als steun aanvaard. Het schept geen rang, afhankelijkheid, spiritueel privilege of controle over het Werk. Als je de informatie op de website waardevol vindt, overweeg dan een donatie om het goede werk te steunen en deze informatie naar duizenden kinderen en volwassenen te brengen.",
      "pap": "Sosten ta wordu aseptá solamente komo sosten. E no ta krea rango, dependensia, privilegio spiritual òf kontròl riba e Obra. Si bo ta haña e informashon riba e wèpsait balioso, konsiderá hasi un donashon pa sostené e bon trabou i yeba e informashon aki na miles di mucha i adulto."
    },
    "transparencyTitle": {
      "en": "Transparency",
      "es": "Transparencia",
      "nl": "Transparantie",
      "pap": "Transparensia"
    },
    "transparencyText": {
      "en": "Support The Great Work Experience through one-time or recurring donations. Current public channels and study paths are listed below.",
      "es": "Apoya The Great Work Experience mediante donaciones únicas o recurrentes. A continuación se muestran los canales públicos y las rutas de estudio actuales.",
      "nl": "Steun The Great Work Experience via eenmalige of terugkerende donaties. Hieronder staan de actuele publieke kanalen en studiepaden.",
      "pap": "Sostené The Great Work Experience ku donashonnan un biaha òf rekurrente. Aki bou ta lista e kanalnan públiko i kaminda di estudio aktual."
    },
    "legacyAppeal": {
      "en": "If you find the information on the website valuable, please consider making a donation to support the good work and bring this information to thousands of children and adults.",
      "es": "Si encuentras valiosa la informacion del sitio web, considera hacer una donacion para apoyar el buen trabajo y llevar esta informacion a miles de ninos y adultos.",
      "nl": "Als je de informatie op de website waardevol vindt, overweeg dan een donatie om het goede werk te steunen en deze informatie naar duizenden kinderen en volwassenen te brengen.",
      "pap": "Si bo ta haya e informashon riba e website balioso, konsidera hasi un donashon pa sostene e bon trabou i yeba e informashon aki na miles di mucha i adulto."
    }
  }
};

export const ethicalCovenant = [
  {
    "id": "no-dependency",
    "title": {
      "en": "No Dependency",
      "es": "Sin Dependencia",
      "nl": "Geen Afhankelijkheid",
      "pap": "Sin Dependensia"
    },
    "text": {
      "en": "No dependency creation.",
      "es": "No crear dependencia.",
      "nl": "Geen afhankelijkheid creeren.",
      "pap": "No krea dependensia."
    },
    "image": "/assets/images/covenant-no-dependency.png",
    "imageAlt": "A teacher opens a gate while the student walks forward independently"
  },
  {
    "id": "no-exploitation",
    "title": {
      "en": "No Exploitation",
      "es": "Sin Explotación",
      "nl": "Geen Uitbuiting",
      "pap": "Sin Eksplotashon"
    },
    "text": {
      "en": "No exploitation of psychological vulnerability.",
      "es": "No explotar vulnerabilidad psicologica.",
      "nl": "Geen uitbuiting van psychologische kwetsbaarheid.",
      "pap": "No eksplota vulnerabilidat psikologiko."
    },
    "image": "/assets/images/covenant-no-exploitation.png",
    "imageAlt": "A protected healing chamber representing consent and emotional safety"
  },
  {
    "id": "functional-hierarchy",
    "title": {
      "en": "Functional Hierarchy",
      "es": "Jerarquía Funcional",
      "nl": "Functionele Hiërarchie",
      "pap": "Hierarkia Funshonal"
    },
    "text": {
      "en": "Functional hierarchy only.",
      "es": "Solo jerarquia funcional.",
      "nl": "Alleen functionele hierarchie.",
      "pap": "Solamente hierarkia funshonal."
    },
    "image": "/assets/images/covenant-functional-hierarchy.png",
    "imageAlt": "A coordinated temple building site representing hierarchy by function"
  },
  {
    "id": "transparent-uncertainty",
    "title": {
      "en": "Transparent Uncertainty",
      "es": "Incertidumbre Transparente",
      "nl": "Transparante Onzekerheid",
      "pap": "Inkertidumbre Transparente"
    },
    "text": {
      "en": "Transparency about uncertainty.",
      "es": "Transparencia sobre la incertidumbre.",
      "nl": "Transparantie over onzekerheid.",
      "pap": "Transparensia tokante inkertidumbre."
    },
    "image": "/assets/images/covenant-transparent-uncertainty.png",
    "imageAlt": "A night observatory where teacher and student examine the unknown together"
  },
  {
    "id": "belongs-to-everyone",
    "title": {
      "en": "Belongs To Everyone",
      "es": "Pertenece a Todos",
      "nl": "Behoort Aan Iedereen",
      "pap": "Ta Pertenesé na Tur Hende"
    },
    "text": {
      "en": "The work belongs to everyone.",
      "es": "La Obra pertenece a todos.",
      "nl": "Het Werk behoort aan iedereen toe.",
      "pap": "E Obra ta pertenece na tur hende."
    },
    "image": "/assets/images/covenant-belongs-to-everyone.png",
    "imageAlt": "An open courtyard with shared light representing common inheritance"
  }
];

export const founder = {
  "name": "glenn \"eduard\" tramm",
  "role": {
    "en": "Anarchist, independent researcher, and passionate advocate for truth, freedom, and natural law.",
    "es": "Anarquista, investigador independiente y defensor apasionado de la verdad, la libertad y la ley natural.",
    "nl": "Anarchist, onafhankelijk onderzoeker en bevlogen pleitbezorger van waarheid, vrijheid en natuurwet.",
    "pap": "Anarkista, investigado independiente i defensor apasiona di berdat, libertat i lei natural."
  },
  "biography": [
    {
      "en": "glenn tramm is an anarchist, independent researcher, and passionate advocate for truth, freedom, and natural law. A dedicated scholar of Ancient Egypt and its antiquities, he channels his profound interests into creating content that spreads awareness of natural law, metaphysics, and universal principles. glenn's work explores diverse fields, including occultism, spirituality, symbology, and consciousness studies, aiming to uncover and share deeper truths about human existence and morality.",
      "es": "glenn tramm es anarquista, investigador independiente y defensor apasionado de la verdad, la libertad y la ley natural. Estudioso dedicado del Antiguo Egipto y sus antigüedades, canaliza sus profundos intereses en la creación de contenido que difunde la conciencia de la ley natural, la metafísica y los principios universales. La obra de glenn explora campos diversos, como el ocultismo, la espiritualidad, la simbología y los estudios de la conciencia, con el fin de descubrir y compartir verdades más profundas sobre la existencia humana y la moralidad.",
      "nl": "glenn tramm is anarchist, onafhankelijk onderzoeker en bevlogen pleitbezorger van waarheid, vrijheid en natuurwet. Als toegewijd kenner van het oude Egypte en zijn oudheden kanaliseert hij zijn diepe interesses in het maken van content die bewustzijn verspreidt over natuurwet, metafysica en universele principes. glenns werk verkent uiteenlopende gebieden, waaronder occultisme, spiritualiteit, symboliek en bewustzijnsstudies, met als doel diepere waarheden over het menselijk bestaan en moraliteit te ontdekken en te delen.",
      "pap": "glenn tramm ta un anarkista, investigadó independiente i defensor apasioná di bèrdat, libertat i lei natural. Komo un studioso dediká di Egipto Antiguo i su antiguedatnan, e ta kanalisá su interesnan profundo den kreashon di kontenido ku ta plama konsenshi tokante lei natural, metafísika i prinsipionan universal. E trabou di glenn ta eksplorá vários área, inkluyendo okultismo, spiritualidat, simbologia i estudio di konsenshi, ku e meta di deskubrí i kompartí bèrdatnan mas profundo tokante eksistensia humano i moralidat."
    },
    {
      "en": "In January 2019, glenn began writing Anarkhos in English, Spanish, Dutch - a book aimed at compiling this knowledge for his children. By February 2020, he started authoring thought-provoking articles to address recurring questions from friends, laying the groundwork for what would become his digital presence. Responding to his children's curiosity about moral philosophy, glenn launched his website, The Great Work Experience, in 2020, serving as a hub for his insights.",
      "es": "En enero de 2019, glenn comenzó a escribir Anarkhos en inglés, español y neerlandés, un libro destinado a recopilar este conocimiento para sus hijos. Para febrero de 2020, empezó a escribir artículos que invitan a la reflexión para responder a las preguntas recurrentes de sus amigos, sentando las bases de lo que se convertiría en su presencia digital. Respondiendo a la curiosidad de sus hijos por la filosofía moral, glenn lanzó su sitio web, The Great Work Experience, en 2020, que sirve como centro de sus ideas.",
      "nl": "In januari 2019 begon glenn met het schrijven van Anarkhos in het Engels, Spaans en Nederlands - een boek bedoeld om deze kennis voor zijn kinderen te bundelen. Tegen februari 2020 begon hij prikkelende artikelen te schrijven om terugkerende vragen van vrienden te beantwoorden, en legde zo de basis voor wat zijn digitale aanwezigheid zou worden. Als antwoord op de nieuwsgierigheid van zijn kinderen naar morele filosofie lanceerde glenn in 2020 zijn website, The Great Work Experience, als knooppunt voor zijn inzichten.",
      "pap": "Na yanüari 2019, glenn a kuminsá skirbi Anarkhos na ingles, spañó i hulandes - un buki ku meta di rekopilá e konosementu aki pa su yunan. Pa febrüari 2020, el a kuminsá skirbi artíkulonan ku ta pone bo pensa pa kontestá preguntanan rekurente di amigunan, poniendo e base di loke lo bira su presensia digital. Respondiendo na e kuriosidat di su yunan tokante filosofia moral, glenn a lansa su wèpsait, The Great Work Experience, na 2020, ku ta sirbi komo un sentro pa su ideanan."
    },
    {
      "en": "October 2020 marked the beginning of The Great Work Experience podcast, where glenn tackled moral and philosophical questions in a concise, accessible format, sharing his discoveries with a broader audience. By September 2021, he initiated a live-streamed Q&A series, Eigen Pad (\"Your Own Path\"), catering to Dutch-speaking listeners. During this time, glenn also joined the One Great Work Network, expanding his outreach and collaborative efforts with like-minded advocates.",
      "es": "Octubre de 2020 marcó el inicio del pódcast The Great Work Experience, donde glenn abordó cuestiones morales y filosóficas en un formato conciso y accesible, compartiendo sus descubrimientos con un público más amplio. Para septiembre de 2021, inició una serie de preguntas y respuestas en directo, Eigen Pad (\"Tu Propio Camino\"), dirigida a oyentes neerlandófonos. Durante este tiempo, glenn también se unió a la One Great Work Network, ampliando su alcance y su colaboración con defensores afines.",
      "nl": "Oktober 2020 markeerde het begin van de The Great Work Experience-podcast, waarin glenn morele en filosofische vragen in een beknopt, toegankelijk formaat behandelde en zijn ontdekkingen met een breder publiek deelde. Tegen september 2021 startte hij een live-gestreamde Q&A-serie, Eigen Pad (\"Your Own Path\"), gericht op Nederlandstalige luisteraars. In deze periode sloot glenn zich ook aan bij het One Great Work Network, waarmee hij zijn bereik en samenwerking met gelijkgestemde pleitbezorgers vergrootte.",
      "pap": "Òktober 2020 a marka e komienso di e podcast The Great Work Experience, kaminda glenn a trata preguntanan moral i filosófiko den un formato konsiso i aksesibel, kompartiendo su deskubrimentunan ku un públiko mas amplio. Pa sèptèmber 2021, el a inisiá un seri di pregunta i kontesta na bibo, Eigen Pad (\"Bo Mes Kaminda\"), dirigí na skuchadónan ku ta papia hulandes. Durante e tempu aki, glenn tambe a uni na e One Great Work Network, ekspandiendo su alkanse i kolaborashon ku defensornan di mesun pensamentu."
    },
    {
      "en": "glenn's journey reflects his commitment to exploring and communicating the fundamental principles that govern human experience, inspiring others to pursue their own paths to truth and self-sovereignty.",
      "es": "El recorrido de glenn refleja su compromiso con explorar y comunicar los principios fundamentales que rigen la experiencia humana, inspirando a otros a seguir sus propios caminos hacia la verdad y la autosoberanía.",
      "nl": "glenns reis weerspiegelt zijn toewijding aan het verkennen en overdragen van de fundamentele principes die de menselijke ervaring sturen, en inspireert anderen om hun eigen pad naar waarheid en zelf-soevereiniteit te volgen.",
      "pap": "E biahe di glenn ta reflehá su kompromiso pa eksplorá i komuniká e prinsipionan fundamental ku ta goberná eksperensia humano, inspirando otronan pa sigui nan mes kaminda pa bèrdat i outo-soberania."
    }
  ],
  "image": "/assets/images/bio2.png",
  "imageAlt": "glenn tramm biography image",
  "memberships": [
    {
      "id": "ctaa",
      "label": {
        "en": "CTAA Member #: 10666372",
        "es": "Miembro CTAA #: 10666372",
        "nl": "CTAA-lid #: 10666372",
        "pap": "Miembro CTAA #: 10666372"
      },
      "href": "https://www.ctaamembers.com/",
      "image": "/assets/images/ctaa-logo.png"
    }
  ],
  "books": [
    {
      "id": "anarkhos-en",
      "label": {
        "en": "Anarkhos — English",
        "es": "Anarkhos — English",
        "nl": "Anarkhos — English",
        "pap": "Anarkhos — English"
      },
      "href": "https://www.amazon.com/dp/B0DVZ2NWWX"
    },
    {
      "id": "anarkhos-es",
      "label": {
        "en": "Anarkhos — Spanish",
        "es": "Anarkhos — Spanish",
        "nl": "Anarkhos — Spanish",
        "pap": "Anarkhos — Spanish"
      },
      "href": "https://www.amazon.es/dp/B0DW8Y6M6Z"
    },
    {
      "id": "anarkhos-nl",
      "label": {
        "en": "Anarkhos — Dutch",
        "es": "Anarkhos — Dutch",
        "nl": "Anarkhos — Dutch",
        "pap": "Anarkhos — Dutch"
      },
      "href": "https://www.amazon.nl/dp/B0DW44SM2T"
    }
  ],
  "networks": [
    {
      "id": "one-great-work-network",
      "label": {
        "en": "One Great Work Network",
        "es": "One Great Work Network",
        "nl": "One Great Work Network",
        "pap": "One Great Work Network"
      },
      "href": "https://onegreatworknetwork.com/glenn-tramm"
    },
    {
      "id": "ctaa-members",
      "label": {
        "en": "CTAA Members",
        "es": "CTAA Members",
        "nl": "CTAA Members",
        "pap": "CTAA Members"
      },
      "href": "https://www.ctaamembers.com/"
    }
  ],
  "socials": [
    {
      "id": "youtube",
      "label": {
        "en": "YouTube",
        "es": "YouTube",
        "nl": "YouTube",
        "pap": "YouTube"
      },
      "href": "https://www.youtube.com/@TheGreatWorkExperience"
    },
    {
      "id": "rss",
      "label": {
        "en": "RSS Feed",
        "es": "RSS Feed",
        "nl": "RSS Feed",
        "pap": "RSS Feed"
      },
      "href": "https://thegreatworkexperience.com/tgwe-rssfeed.xml"
    },
    {
      "id": "odysee",
      "label": {
        "en": "Odysee",
        "es": "Odysee",
        "nl": "Odysee",
        "pap": "Odysee"
      },
      "href": "https://odysee.com/@TGWE:0"
    },
    {
      "id": "twitch",
      "label": {
        "en": "Twitch",
        "es": "Twitch",
        "nl": "Twitch",
        "pap": "Twitch"
      },
      "href": "https://www.twitch.tv/tgwe888"
    },
    {
      "id": "tiktok",
      "label": {
        "en": "TikTok",
        "es": "TikTok",
        "nl": "TikTok",
        "pap": "TikTok"
      },
      "href": "https://www.tiktok.com/@thegreatworkexperience?_t=8jE7vNES9rh&_r=1"
    },
    {
      "id": "instagram",
      "label": {
        "en": "Instagram",
        "es": "Instagram",
        "nl": "Instagram",
        "pap": "Instagram"
      },
      "href": "https://www.instagram.com/thegreatworkexperience?igsh=eWNwZG05bzZmNzE1"
    }
  ]
};

export const supportLinks = [
  {
    "id": "paypal",
    "label": {
      "en": "PayPal",
      "es": "PayPal",
      "nl": "PayPal",
      "pap": "PayPal"
    },
    "href": "https://www.paypal.com/donate/?hosted_button_id=LEMTCMZBPSP84",
    "kind": "donation",
    "source": "donations.html hosted_button_id=LEMTCMZBPSP84",
    "image": "/assets/images/paypal.png",
    "imageAlt": "PayPal donation logo",
    "qrImage": "/assets/images/paypal-donations-qr.png",
    "description": {
      "en": "Click the PayPal donation button or scan the QR code. You can then log in to PayPal and complete the donation.",
      "es": "Haz clic en el boton de donacion de PayPal o escanea el codigo QR. Luego inicia sesion en PayPal y completa la donacion.",
      "nl": "Klik op de PayPal-donatieknop of scan de QR-code. Log daarna in bij PayPal en rond de donatie af.",
      "pap": "Klek riba e boton di donashon di PayPal of sken e codigo QR. Despues drenta PayPal i komplet? e donashon."
    }
  }
];

export const cryptoDonations = [
  {
    "id": "bitcoin",
    "label": {
      "en": "Donate with Bitcoin",
      "es": "Donar con Bitcoin",
      "nl": "Doneer met Bitcoin",
      "pap": "Dona ku Bitcoin"
    },
    "symbol": "BTC",
    "address": "bc1qvkzl9pzjr5se9c7zgw7t0fpvh89spksmxvr3kt",
    "image": "/assets/images/bitcoin.png",
    "imageAlt": "Bitcoin donation image",
    "qrImage": "/assets/images/bitcoin-qr.png",
    "source": "donations.html bitcoin"
  },
  {
    "id": "monero",
    "label": {
      "en": "Donate with Monero",
      "es": "Donar con Monero",
      "nl": "Doneer met Monero",
      "pap": "Dona ku Monero"
    },
    "symbol": "XMR",
    "address": "49EPQttqisX25KeJM2dFWMCzc3nDH7GuMi6YDafa5tpjfJxL4kn121nXv13YPNYyh5G2ZAQqxKW7nYrvrzkmRoqBLNEbbc6",
    "image": "/assets/images/monero.png",
    "imageAlt": "Monero donation image",
    "qrImage": "/assets/images/monero-qr_.png",
    "source": "donations.html monero"
  },
  {
    "id": "litecoin",
    "label": {
      "en": "Donate with Litecoin",
      "es": "Donar con Litecoin",
      "nl": "Doneer met Litecoin",
      "pap": "Dona ku Litecoin"
    },
    "symbol": "LTC",
    "address": "LeGhJJYXhK18H5xtu6Kx8NwNhPfsk8AvKW",
    "image": "/assets/images/litecoin.png",
    "imageAlt": "Litecoin donation image",
    "qrImage": "/assets/images/litecoin-qr.png",
    "source": "donations.html litecoin"
  },
  {
    "id": "dash",
    "label": {
      "en": "Donate with Dash",
      "es": "Donar con Dash",
      "nl": "Doneer met Dash",
      "pap": "Dona ku Dash"
    },
    "symbol": "DASH",
    "address": "XgXkRJFGbfQbfnU2vyiGWAhwrWNT7Cme8r",
    "image": "/assets/images/dash.png",
    "imageAlt": "Dash donation image",
    "qrImage": "/assets/images/dash-qr.png",
    "source": "donations.html dash"
  },
  {
    "id": "ethereum",
    "label": {
      "en": "Donate with Ethereum",
      "es": "Donar con Ethereum",
      "nl": "Doneer met Ethereum",
      "pap": "Dona ku Ethereum"
    },
    "symbol": "ETH",
    "address": "0xcb07Ee73D8e82CA83eC5348C4865D07B24FC4A92",
    "image": "/assets/images/ethereum.png",
    "imageAlt": "Ethereum donation image",
    "qrImage": "/assets/images/ethereum-qr.png",
    "source": "donations.html ethereum"
  },
  {
    "id": "bitcoin-cash",
    "label": {
      "en": "Donate with Bitcoin Cash",
      "es": "Donar con Bitcoin Cash",
      "nl": "Doneer met Bitcoin Cash",
      "pap": "Dona ku Bitcoin Cash"
    },
    "symbol": "BCH",
    "address": "qper03sds7hl0x39aemj5ctdluu30epfxskqmtc5lv",
    "image": "/assets/images/bitcoin-cash.png",
    "imageAlt": "Bitcoin Cash donation image",
    "qrImage": "/assets/images/bitcoin-cash-qr.png",
    "source": "donations.html bitcoin-cash"
  },
  {
    "id": "bitcoin-sv",
    "label": {
      "en": "Donate with Bitcoin SV",
      "es": "Donar con Bitcoin SV",
      "nl": "Doneer met Bitcoin SV",
      "pap": "Dona ku Bitcoin SV"
    },
    "symbol": "BSV",
    "address": "1B5zbVZED1NrZbnwLUwiMRGCeRuzbf99Fx",
    "image": "/assets/images/bitcoin-sv.png",
    "imageAlt": "Bitcoin SV donation image",
    "qrImage": "/assets/images/bitcoin-sv-qr.png",
    "source": "donations.html bitcoin-sv"
  }
];
